import React, { useState } from "react";
import Buttoncom from "./common/button.component";
import { Form, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const navigate = useNavigate();

  function authentication() {
    if (email === "farhan@gmail.com" && password === "12345") {
      navigate("/counter");
    } else {
      alert("You are Wrong!");
    }
  }

  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-lg-6">
            <InputGroup className="mb-3">
              <InputGroup.Text id="basic-addon1">Email</InputGroup.Text>
              <Form.Control
                placeholder="Username"
                aria-label="Username"
                aria-describedby="basic-addon1"
                type="email"
                onChange={(e) =>{
                    setEmail(e.target.value)
                }}
              />
            </InputGroup>

            <InputGroup className="mb-3">
              <InputGroup.Text id="basic-addon1">Password</InputGroup.Text>
              <Form.Control
                placeholder="password"
                aria-label="password"
                aria-describedby="basic-addon1"
                type="password"
                onChange={(e) =>{
                    setPassword(e.target.value)
                }}
              />
            </InputGroup>

            <Buttoncom text="LogIn" variant="primary" event={authentication} />

            <br />
            <br />

            <p>Email: farhan@gmail.com</p>
            <p>Pass: 12345</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
